<div [class.disabled]="_disabled" (click)="openPublicationFilters()">
  <span>{{ 'PUBLICATIONS_LIST.FILTER' | translate }}</span>
  <img src="assets/imgs/icons/filter.svg" />
</div>
